/// <amd-module name="SuiteCommerce.Blog.Pagination.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Pagination.Model", ["require", "exports", "Backbone", "SuiteCommerce.Blog.Pagination.Button.Collection", "SuiteCommerce.Blog.Pagination.Configuration", "underscore", "SuiteCommerce.Blog.Pagination.Button.Model"], function (require, exports, Backbone_1, Pagination_Button_Collection_1, Pagination_Configuration_1, _, Pagination_Button_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DEFAULT_PAGINATION_EVENT_ID = 'pagination_triggered';
    var PaginationModel = /** @class */ (function (_super) {
        __extends(PaginationModel, _super);
        function PaginationModel(options) {
            var _this = _super.call(this, options) || this;
            _this.buttonsToShowPerBlock = 5;
            _this.on('change:buttons', function () {
                _this.visibleButtonGroup = _this.selectButtonGroupToShow();
            });
            return _this;
        }
        Object.defineProperty(PaginationModel.prototype, "total", {
            get: function () {
                return this.get('total');
            },
            set: function (total) {
                this.set('total', total);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaginationModel.prototype, "pageSize", {
            get: function () {
                return this.get('pageSize');
            },
            set: function (pageSize) {
                this.set('pageSize', pageSize);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaginationModel.prototype, "currentPage", {
            get: function () {
                return this.get('currentPage');
            },
            set: function (currentPage) {
                this.set('currentPage', currentPage);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaginationModel.prototype, "buttons", {
            get: function () {
                return this.get('buttons');
            },
            set: function (buttons) {
                this.set('buttons', buttons);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaginationModel.prototype, "visibleButtonGroup", {
            get: function () {
                if (!this.get('visibleButtonGroup')) {
                    this.visibleButtonGroup = this.selectButtonGroupToShow();
                }
                return this.get('visibleButtonGroup');
            },
            set: function (buttons) {
                this.set('visibleButtonGroup', buttons);
            },
            enumerable: true,
            configurable: true
        });
        PaginationModel.prototype.selectButtonGroupToShow = function () {
            var _this = this;
            var visibleButtons = new Pagination_Button_Collection_1.PaginationButtonCollection();
            if (this.buttons.size() > 5) {
                var buttonsGroups_1 = _.chunk(this.buttons.models, this.buttonsToShowPerBlock);
                var activeGroupIndex_1;
                buttonsGroups_1.forEach(function (group, index) {
                    if (group.filter(function (button) {
                        return button.isActive;
                    }).length > 0) {
                        activeGroupIndex_1 = index;
                        if (group.length < _this.buttonsToShowPerBlock) {
                            visibleButtons = new Pagination_Button_Collection_1.PaginationButtonCollection(_.last(buttonsGroups_1[index - 1], _this.buttonsToShowPerBlock - group.length));
                            visibleButtons.add(group);
                        }
                        else {
                            visibleButtons = new Pagination_Button_Collection_1.PaginationButtonCollection(group);
                        }
                    }
                });
                return this.addNavigationButtons(buttonsGroups_1, activeGroupIndex_1, visibleButtons);
            }
            visibleButtons.add(this.buttons.models);
            return visibleButtons;
        };
        PaginationModel.prototype.addNavigationButtons = function (groups, activeGroupIndex, buttons) {
            var previousGroup = (groups[activeGroupIndex - 1]) ?
                groups[activeGroupIndex - 1] : null;
            var nextGroup = (groups[activeGroupIndex + 1]) ?
                groups[activeGroupIndex + 1] : null;
            if (previousGroup) {
                buttons.models[0].hideDivider = true;
                buttons.unshift(new Pagination_Button_Model_1.PaginationButtonModel({
                    isEnabledEventsHandling: this.isEnabledEventsHandling,
                    isActive: false,
                    pageNumber: previousGroup[this.buttonsToShowPerBlock - 1].pageNumber,
                    label: '<',
                    hideDivider: true,
                }));
            }
            if (nextGroup) {
                buttons.add(new Pagination_Button_Model_1.PaginationButtonModel({
                    isEnabledEventsHandling: this.isEnabledEventsHandling,
                    isActive: false,
                    pageNumber: nextGroup[0].pageNumber,
                    label: '>',
                    hideDivider: true,
                }));
            }
            return buttons;
        };
        Object.defineProperty(PaginationModel.prototype, "paginationLabel", {
            get: function () {
                return this.get('paginationLabel') || Pagination_Configuration_1.PaginationConfiguration.paginationLabel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaginationModel.prototype, "isEnabledEventsHandling", {
            get: function () {
                return this.get('isEnabledEventsHandling');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaginationModel.prototype, "paginationEventId", {
            get: function () {
                return this.get('paginationEventId') || exports.DEFAULT_PAGINATION_EVENT_ID;
            },
            enumerable: true,
            configurable: true
        });
        return PaginationModel;
    }(Backbone_1.Model));
    exports.PaginationModel = PaginationModel;
});
